import { useEffect, useRef, useState } from "react";

/**
 * Téléphone (sous 768 px) : les offres sont des cartes qui défilent sur le côté (on voit le bord des voisines),
 * en commençant par la carte startIndex au centre ; `active` indique la carte affichée (pour les points),
 * `goTo(i)` y fait défiler. Utilisé sur l'accueil et sur la page Offres. Ordinateur : grille habituelle.
 */
export default function useOfferCarousel(count, startIndex) {
  const ref = useRef(null);
  const [active, setActive] = useState(startIndex);
  useEffect(() => {
    const el = ref.current;
    if (!el || !count || window.innerWidth >= 768) return undefined;
    const cards = () => [...el.children];
    const center = (i) => {
      const c = cards()[i];
      if (c) el.scrollLeft = c.offsetLeft - (el.clientWidth - c.offsetWidth) / 2;
    };
    center(startIndex);
    const onScroll = () => {
      const mid = el.scrollLeft + el.clientWidth / 2;
      let best = 0;
      cards().forEach((c, i) => {
        if (Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid) < Math.abs(cards()[best].offsetLeft + cards()[best].offsetWidth / 2 - mid)) best = i;
      });
      setActive(best);
    };
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, [count, startIndex]);
  const goTo = (i) => {
    const el = ref.current;
    const c = el?.children[i];
    if (c) el.scrollTo({ left: c.offsetLeft - (el.clientWidth - c.offsetWidth) / 2, behavior: "smooth" });
  };
  return { ref, active, goTo };
}
